import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { MetaService } from '@app/core/services/meta.service';
import { NavItem } from '@app/interfaces/nav-item';
import { NavComponent } from '@app/layout/nav/nav.component';
import { environment } from '@envs/environment';

@Component({
  selector: 'app-privacy-policy-page',
  templateUrl: './privacy-policy.page.html',
  styleUrls: ['./privacy-policy.page.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NavComponent],
})
export class PrivacyPolicyPage implements OnInit {
  constructor(private metaService: MetaService) {}

  protected environment = environment;

  protected navItems: NavItem[] = [{ label: 'Privacy policy' }];

  ngOnInit(): void {
    const metadata = {
      title: 'ImageBase.pro – Privacy Policy & Data Protection',
      description:
        'Learn how ImageBase.pro collects, uses, and protects your personal data. Read our privacy policy to understand your rights and security measures.',
      keywords:
        'ImageBase.pro privacy policy, data protection, personal data, user privacy, stock image platform policy, data security',
    };

    this.metaService.setMetadata(metadata);
  }
}
